import { Routes } from '@angular/router';

import { AuthGuard } from '@auth0/auth0-angular';

import { adminGuard } from './core/guards/admin.guard';
import { unsavedChangesGuard } from './core/guards/unsaved-changes.guard';
import { ShellComponent } from './layout/shell/shell.component';

export const routes: Routes = [
  {
    path: '',
    component: ShellComponent,
    canActivate: [AuthGuard],
    children: [
      {
        // Landing page: send users straight into Registro de Peticiones (the 'process-records'
        // tool doc now renders RequestLogComponent) instead of a blank shell.
        path: '',
        pathMatch: 'full',
        redirectTo: 'support/process-records',
      },
      {
        path: 'admin/tools',
        canActivate: [adminGuard],
        loadComponent: () =>
          import('./features/admin/tool-management/tool-management.component').then(
            (m) => m.ToolManagementComponent,
          ),
      },
      {
        path: 'admin/categories',
        canActivate: [adminGuard],
        loadComponent: () =>
          import('./features/admin/category-management/category-management.component').then(
            (m) => m.CategoryManagementComponent,
          ),
      },
      {
        path: 'admin/clients',
        canActivate: [adminGuard],
        loadComponent: () =>
          import('./features/admin/client-control/client-control.component').then(
            (m) => m.ClientControlComponent,
          ),
      },
      {
        path: 'admin/toolbelt-schemas',
        canActivate: [adminGuard],
        loadComponent: () =>
          import('./features/admin/toolbelt-schema-management/toolbelt-schema-management.component').then(
            (m) => m.ToolbeltSchemaManagementComponent,
          ),
      },
      {
        // Must come before the ':id' route below — otherwise 'new' would be captured as an id.
        path: 'admin/toolbelt-schemas/new',
        canActivate: [adminGuard],
        loadComponent: () =>
          import('./features/admin/toolbelt-schema-editor/toolbelt-schema-editor.component').then(
            (m) => m.ToolbeltSchemaEditorComponent,
          ),
      },
      {
        path: 'admin/toolbelt-schemas/:id',
        canActivate: [adminGuard],
        loadComponent: () =>
          import('./features/admin/toolbelt-schema-editor/toolbelt-schema-editor.component').then(
            (m) => m.ToolbeltSchemaEditorComponent,
          ),
      },
      {
        path: 'admin/schema-change-requests',
        canActivate: [adminGuard],
        loadComponent: () =>
          import('./features/admin/schema-change-requests/schema-change-requests-inbox.component').then(
            (m) => m.SchemaChangeRequestsInboxComponent,
          ),
      },
      {
        path: 'admin/roles',
        canActivate: [adminGuard],
        loadComponent: () =>
          import('./features/admin/role-management/role-management.component').then(
            (m) => m.RoleManagementComponent,
          ),
      },
      {
        path: 'admin/users/new',
        canActivate: [adminGuard],
        canDeactivate: [unsavedChangesGuard],
        loadComponent: () =>
          import('./features/admin/user-management/user-create.component').then(
            (m) => m.UserCreateComponent,
          ),
      },
      {
        path: 'admin/users',
        canActivate: [adminGuard],
        loadComponent: () =>
          import('./features/admin/user-management/user-management.component').then(
            (m) => m.UserManagementComponent,
          ),
      },
      {
        path: ':categoryCode/:toolId',
        loadComponent: () =>
          import('./features/tool-viewer/tool-viewer.component').then((m) => m.ToolViewerComponent),
      },
    ],
  },
  {
    path: 'login',
    loadComponent: () => import('./features/login/login.component').then((m) => m.LoginComponent),
  },
];
